import { Block } from "@/interfaces/copilotTypes";
import React, { useEffect, useState } from "react";
import ThoughtChain from "./ThoughtChain";
import { motion } from "framer-motion";
import { ChevronRightIcon, CheckCheckIcon } from "lucide-react";
import ThoughtAnalysis from "./ThoughtAnalysis";
import Image from "next/image";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";

function ThoughtChainsView({ block }: { block: Block }) {
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (block.status == "final") {
      setActive(false);
    }
    if (block.status == "pending") {
      setActive(true);
    }
  }, [block.status]);

  return (
    <div className="my-2 rounded-3xl border border-[#3B00900D]/5 p-2 text-sm">
      <div
        className="flex items-start justify-between pr-2"
        onClick={() => setActive(!active)}
      >
        <Image
          src={getFullWebCdnUrl("/copilot/analisys.png")}
          width={24}
          height={24}
          alt="icon"
          className="mr-3"
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />

        <ThoughtAnalysis thoughts={block.thoughts} />

        <motion.div
          className="flex"
          animate={{ rotate: active ? 90 : 0 }}
          transition={{ type: "tween" }}
        >
          <ChevronRightIcon />
        </motion.div>
      </div>
      <motion.div
        className="overflow-y-auto px-3"
        initial={{ maxHeight: 0 }}
        animate={{ maxHeight: active ? "3000px" : 0 }}
        transition={{ type: "tween" }}
      >
        {Array.isArray(block.thoughts) &&
          block.thoughts.map((thought) => (
            <div key={thought._id} className="pt-1">
              <div className="flex items-start py-2 font-medium leading-5">
                <div>
                  {thought.content}
                  {thought.status == "pending" && (
                    <div className="ml-2 inline-block">
                      <div className="typing__dot bg-[#33007E]"></div>
                      <div className="typing__dot bg-[#33007E]"></div>
                      <div className="typing__dot bg-[#33007E]"></div>
                    </div>
                  )}

                  {thought.status == "final" && (
                    <div className="ml-2 inline-flex align-[-2px]">
                      <CheckCheckIcon size={16} />
                    </div>
                  )}
                </div>
              </div>
              <ThoughtChain thought={thought} />
            </div>
          ))}
      </motion.div>
    </div>
  );
}

export default ThoughtChainsView;
